import { Component, Input, OnInit } from '@angular/core';
import { StudentMergedTree } from '../../../model/student-merged-tree';

@Component({
    selector: 'view-children-merge-tree-branches',
    templateUrl: './view-children-merge-tree-branches.component.html',
    styleUrl: './view-children-merge-tree-branches.component.scss'
})
export class ViewChildrenMergeTreeBranchesComponent implements OnInit {
    @Input() tree!: StudentMergedTree;
    @Input() studentMsdNumber!: string;
    @Input() studentId!: number;

    promises: any[] = [];
    isLoading: boolean = true;

    constructor() {}

    ngOnInit(): void {}

    getLayers(num: number) {
        return new Array(num - 1);
    }
}
